import { render, staticRenderFns } from "./QuiltyInsightsGeneralView.vue?vue&type=template&id=5915fc50&"
import script from "./QuiltyInsightsGeneralView.vue?vue&type=script&lang=ts&"
export * from "./QuiltyInsightsGeneralView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5915fc50')) {
      api.createRecord('5915fc50', component.options)
    } else {
      api.reload('5915fc50', component.options)
    }
    module.hot.accept("./QuiltyInsightsGeneralView.vue?vue&type=template&id=5915fc50&", function () {
      api.rerender('5915fc50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "landing/src/views/admin/quiltyInsights/QuiltyInsightsGeneralView.vue"
export default component.exports